import { CanActivateFn } from '@angular/router';

// TODO: se activa cuando el backend esté listo
// import { inject } from '@angular/core';
// import { Router } from '@angular/router';
// import { AuthService } from '../services/auth.service';

export const permissionGuard = (_permission: string): CanActivateFn => {
  return () => {
    // const auth = inject(AuthService);
    // const router = inject(Router);
    // if (auth.hasPermission(_permission)) return true;
    // return router.createUrlTree(['/dashboard']);
    return true;
  };
};
